import { createContext, useContext } from "react";
import Button from "./Button";

// Set by a table's card view, where a row action has room for its label
export const InCard = createContext(false);

// Icon-only row button; the label shows as a tooltip and is read by screen readers. In a card it shows its label
export default function RowAction({ label, Icon, variant = "ghost", ...props }) {
  const inCard = useContext(InCard);
  if (inCard) {
    return (
      <Button size="sm" variant="outline" icon={<Icon className="h-4 w-4" />} {...props}>
        {label}
      </Button>
    );
  }
  return (
    <Button size="icon" variant={variant} title={label} aria-label={label} {...props}>
      <Icon className="h-4 w-4" />
    </Button>
  );
}
